import { jsonFetch } from "@/lib/helpers";
import { ALARM_RULES_REORDER_URL } from "./api-url.constants";
import { AlarmRuleDTO } from "./dtos";
import { API_METHODS } from "../shared";

type ReorderItem = {
  id: string;
  position: number;
};

type ReorderAlarmRulesResponse = {
  data: AlarmRuleDTO[];
};

export const reorderAlarmRules = async (orderedIds: ReorderItem[]): Promise<AlarmRuleDTO[]> => {
  const response = await jsonFetch<ReorderAlarmRulesResponse>(ALARM_RULES_REORDER_URL, {
    method: API_METHODS.PATCH,
    body: JSON.stringify({ orderedIds }),
  });
  return response.data;
};
